/**
 * Extrait les messages d'erreur d'un objet d'erreur Vee-Validate/Zod
 * Gère les différents formats d'erreurs (string, array, object)
 */
export function extractErrorMessages(err: any): string[] {
  if (!err) return [];
  
  if (typeof err === 'string') {
    return [err];
  }
  
  if (Array.isArray(err)) {
    return err.flatMap(e => extractErrorMessages(e)).filter(Boolean);
  }
  
  if (typeof err === 'object') {
    // Erreur Zod avec message
    if (err.message) {
      return [err.message];
    }
    
    // Erreur avec messages multiples
    if (err.messages && Array.isArray(err.messages)) {
      return err.messages;
    }
    
    // Erreur avec clés imbriquées
    const messages: string[] = [];
    for (const key in err) {
      if (err.hasOwnProperty(key)) {
        const nestedMessages = extractErrorMessages(err[key]);
        messages.push(...nestedMessages);
      }
    }
    return messages;
  }
  
  return [];
}

